var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[(_vm.subTitleShow)?_c('sub-title',{staticClass:"title",attrs:{"title":"解决方案"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"all-sole-card"},_vm._l((_vm.solutionCardList),function(item,index){return _c('solution-card',{key:index,attrs:{"need-obj":item}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }